import { useQuery } from "react-query";
import { getDivisions } from "../api/getDivisions";

const useDivisions = () => {
	return useQuery(["divisions"], () => getDivisions());
};

export { useDivisions };
